module.exports = __webpack_public_path__ + "assets/img/sportstar.2cfa459f.jpg";